import { motion } from "framer-motion";
import { FaLine } from "react-icons/fa6";
import { fadeInUp } from "@/components/motionVariants";

const heroBg =
  "https://images.unsplash.com/photo-1690527357727-be759464df56?crop=entropy&cs=srgb&fm=jpg&q=85";

export const HeroSection = ({ lineUrl }) => {
  return (
    <section
      id="hero"
      className="relative flex min-h-[85vh] items-center overflow-hidden"
      data-testid="hero-section"
    >
      <img
        src={heroBg}
        alt="บรรยากาศไพ่ทาโรต์สุดโรแมนติก"
        className="absolute inset-0 h-full w-full object-cover"
        loading="eager"
        data-testid="hero-background-image"
      />
      <div
        className="absolute inset-0 bg-black/35"
        data-testid="hero-overlay"
      />
      <div
        className="hero-glow absolute -right-10 top-8 h-64 w-64 rounded-full blur-3xl"
        data-testid="hero-glow-orb"
      />
      <div
        className="absolute -bottom-12 left-10 h-52 w-52 rounded-full bg-rose/20 blur-3xl animate-float-slow"
        data-testid="hero-rose-orb"
      />
      <div className="relative z-10 w-full">
        <div className="mx-auto max-w-md px-6 py-20 text-center md:max-w-4xl md:px-12">
          <motion.p
            {...fadeInUp}
            className="mb-4 text-xs uppercase tracking-[0.4em] text-rose"
            data-testid="hero-eyebrow"
          >
            Love Clarity Session
          </motion.p>
          <motion.h1
            {...fadeInUp}
            className="font-serif text-4xl leading-tight text-white md:text-6xl"
            data-testid="hero-headline"
          >
            เขายังรักคุณอยู่ไหม…
            <br />หรือหัวใจของเขากำลังเปลี่ยนไป?
          </motion.h1>
          <motion.p
            {...fadeInUp}
            className="mt-6 text-base text-white/90 md:text-lg"
            data-testid="hero-subheadline"
          >
            การอ่านไพ่ทาโรต์แบบส่วนตัว 1-ต่อ-1
            <br />พื้นที่ปลอดภัยสำหรับหัวใจของคุณ
            <br />100% เป็นความลับ
          </motion.p>
          <motion.div {...fadeInUp} className="mt-8" data-testid="hero-cta-wrapper">
            <a
              href={lineUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 rounded-full bg-line px-8 py-4 text-base font-semibold text-white shadow-glow-line transition-shadow duration-300 hover:shadow-[0_0_32px_rgba(0,195,0,0.7)]"
              data-testid="hero-primary-cta"
              aria-label="ทัก LINE ตอนนี้"
            >
              <FaLine className="text-xl" data-testid="hero-primary-cta-icon" />
              <span data-testid="hero-primary-cta-text">ทัก LINE ตอนนี้</span>
            </a>
          </motion.div>
          <motion.div
            {...fadeInUp}
            className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm text-white/80"
            data-testid="hero-trust-signals"
          >
            <span className="rounded-full border border-white/30 px-4 py-2" data-testid="hero-trust-signal-1">
              ไม่ตัดสิน
            </span>
            <span className="rounded-full border border-white/30 px-4 py-2" data-testid="hero-trust-signal-2">
              รับฟังด้วยความเข้าใจ
            </span>
            <span className="rounded-full border border-white/30 px-4 py-2" data-testid="hero-trust-signal-3">
              จำกัดจำนวนคิวต่อวัน
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};